import {api} from '@/api/factory';

class MassAdition {
    constructor() {}

    save(serial_id, season_id, data) {
        // /api/v1/content-manager/series/{serial_id}/seasons/{season_id}/mass_episodes
        return api({
            url: `/v1/content-manager/series/${serial_id}/seasons/${season_id}/mass_episodes`,
            method: 'POST',
            data: data
        })
    }
}

export default MassAdition